import { PetsState, SetPetsAction } from "../types";

export const SET_PETS = "SET_PETS";

export const setNewPets = (pets: PetsState): SetPetsAction => {
  return {
    type: SET_PETS,
    pets,
  };
};
